import React from "react";
import { observer } from "mobx-react";

const SurveyGridBody = observer((props) => {
    return (
        <tbody>
            {React.Children.map(props.children, (row, index) => (
                React.cloneElement(row, {
                    hiddenColumns: props.hiddenColumns,
                    indexNum: index,
                    tableName: props.tableName,
                    isCompact: props.isCompact
                })
            ))}
        </tbody>
    );
});

export default SurveyGridBody;
